module.exports = __webpack_public_path__ + "static/aws-cloud-8028854cd8d8ddf067056e1ff884ca5b.png";